// WHAT: Thin-Wrapper um `ScoreCard` für den Oura-Activity-Score
// WHY:  Kapselt Titel/Beschreibung und erlaubt konsistenten Gebrauch im Oura-Dashboard
// DOMAIN: health → oura → molecules
// DEPENDENCIES: `ScoreCard`-Molecule
import { type FC } from "react";

import { ScoreCard } from "./ScoreCard";

interface ActivityScoreProperties {
  score: number;
  trend?: "down" | "stable" | "up";
  trendValue?: number;
}

export const ActivityScore: FC<ActivityScoreProperties> = ({ score, trend, trendValue }) => {
  return (
    <ScoreCard
      description="Daily activity level"
      maxScore={100}
      score={score}
      title="Activity Score"
      {...(trend !== undefined && { trend })}
      {...(trendValue !== undefined && { trendValue })}
    />
  );
};
